import cn from 'classnames';
import styles from './styles.scss';
import { HtmlHTMLAttributes } from 'react';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';

interface HeaderProps extends HtmlHTMLAttributes<HTMLDivElement> {
  invert?: boolean;
}
export const Header = ({ invert, className, children, ...props }: HeaderProps) => {
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  return (
    <div
      className={cn(
        styles.header,
        { [styles.invert]: invert, [styles.blackFriday]: blackFridayIsActive },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
